const fragment = `
  id
  name
  description
  defaultImageUrl
  imagesCount
  hashId
  externalId
  availability
  status
  displayOrder
  project {
    id
    name
  }  
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
`;

export const listProjectBuildingsQuery = `
  query ListProjectBuildings(
    $filter: ProjectBuildingFilterInput
  ) {
    items: listProjectBuildings(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getProjectBuildingQuery = `
  query GetProjectBuilding($id: Int!) {
    item: getProjectBuilding(id: $id) {
      ${fragment}
    }
  }
`;

export const createProjectBuildingQuery = `
  mutation CreateProjectBuilding(
    $input: CreateProjectBuildingInput!
  ) {
    item: createProjectBuilding(input: $input) {
      ${fragment}
    }
  }
`;

export const updateProjectBuildingQuery = `
  mutation UpdateProjectBuilding(
    $input: UpdateProjectBuildingInput!
  ) {
    item: updateProjectBuilding(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteProjectBuildingQuery = `
  mutation DeleteProjectBuilding(
    $id: Int!
  ) {
    item: deleteProjectBuilding(id: $id) {
      ${fragment}
    }
  }
`;

export const sortProjectBuildingsQuery = `
  mutation SortProjectBuildings(
    $projectId: Int!,
    $ids: [Int!]!
  ) {
    items: sortProjectBuildings(projectId: $projectId, ids: $ids) {
      id
    }
  }
`;
